import { supabase } from "@/lib/supabase";
import { Job } from "../job-by-name";
import { Tables } from "@/types/supabase-types";

export type Bin = Pick<Tables<"Bin">, "id" | "number" | "description">;

export async function getSalesOrderRackBin(job: Job): Promise<Bin> {
  const sentiLocationId = 3;
  const expectedBinName = `Order Rack (${job.number})`;
  const salesOrderRack = (
    await supabase
      .from("Bin")
      .select("id,number,description")
      .eq("locationId", sentiLocationId)
      .like("number", expectedBinName + "%") // NOTE: Use a wildcard to match the bin name because it could have a ` (deleted)` suffix
      .maybeSingle()
      .throwOnError()
  ).data;
  if (!salesOrderRack)
    throw new Error(
      `Failed to find a bin with name '${expectedBinName}' at the 'Senti Solutions Inc.' location. This bin will need to be created manually in SOS before this page can be loaded.`,
    );
  return salesOrderRack;
}
